import { render, staticRenderFns } from "./ConsultConfirm.vue?vue&type=template&id=701e9db2&"
import script from "./ConsultConfirm.vue?vue&type=script&lang=js&"
export * from "./ConsultConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports